import React from 'react';
import { INBOUND_TAG_TEST } from 'components/groups-dashboard/constants';
import { InboundTagStyled } from './styles';

const InboundTag: React.FC = () => {
  return <InboundTagStyled data-test-id={INBOUND_TAG_TEST}>Inbound</InboundTagStyled>;
};

export default InboundTag;
